
import MentorHeader from '../components/MentorHeader';
import MentorSideBar from '../components/MentorSiderBar';
import React,{useState,useEffect} from 'react'

const MentorRequests = () => {
     const [sidebarOpen, setSidebarOpen] = useState(true);
      const [isMobile, setIsMobile] = useState(false);
        const toggleSidebar = () => setSidebarOpen((prev) => !prev);
          useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) setSidebarOpen(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
        <MentorSideBar
              isOpen={sidebarOpen}
              toggleSidebar={toggleSidebar}
              isMobile={isMobile}
         
            />

            <div
                    className={`flex flex-col flex-1 transition-all duration-300 ${isMobile ? "ml-0" : sidebarOpen ? "ml-16 md:ml-20 lg:ml-20" : "ml-0"}`}
                  >
                    <MentorHeader  toggleSidebar={toggleSidebar} isMobile={isMobile} />
                    </div>
    </div>
  )
}

export default MentorRequests
